<template>
  <BaseModal
    v-model:isOpen="isOpen"
    :show-default-footer="false"
    :close-on-overlay-click="false"
    showCloseButton
    :showBackButton="currentStep !== 0"
    content-padding="none"
    size="md"
    title="비밀번호 변경"
    @back="handleBack"
  >
    <div class="px-padding-36 flex w-full flex-col items-center py-10">
      <div class="gap-size-36 flex w-full flex-col items-center">
        <BaseStepper variant="dot" :dot-config="{ count: 3 }" :current="currentStep" />
        <div class="gap-size-8 flex flex-col items-center">
          <span class="text-font-18 font-semibold">{{ stepOptions[currentStep].title }}</span>
          <span class="text-font-14">{{ stepOptions[currentStep].description }}</span>
        </div>
        <PasswordResetEmailSend
          v-if="currentStep === 0"
          @confirm="handleConfirm"
          @cancel="handleCancel"
        />
        <PasswordResetEmailAuth
          v-if="currentStep === 1"
          @confirm="handleConfirm"
          @cancel="handleCancel"
        />
        <ResetPassword v-if="currentStep === 2" @confirm="handleConfirm" @cancel="handleCancel" />
      </div>
    </div>
  </BaseModal>
</template>
<script setup lang="ts">
import PasswordResetEmailSend from '../content/password/PasswordResetEmailSend.vue';
import PasswordResetEmailAuth from '../content/password/PasswordResetEmailAuth.vue';
import ResetPassword from '../content/password/ResetPassword.vue';
import { BaseModal, BaseStepper } from '@template/ui';
import { ref, computed } from 'vue';

const isOpen = defineModel<boolean>('isOpen', { required: true });

const currentStep = ref(0);

const stepOptions = computed(() => {
  return [
    {
      title: '비밀번호 재설정',
      description: '보안을 위해 이메일 인증을 진행합니다',
      confirmButtonLabel: '인증번호 전송',
    },
    {
      title: '인증번호 입력',
      description: '이메일로 전송된 6자리 인증번호를 입력하세요',
      confirmButtonLabel: '인증번호 확인',
    },
    {
      title: '새 비밀번호 설정',
      description: '새로운 비밀번호를 설정하세요',
      confirmButtonLabel: '변경 완료',
    },
  ];
});

const handleConfirm = async () => {
  if (currentStep.value === 0) {
    currentStep.value = 1;
  } else if (currentStep.value === 1) {
    currentStep.value = 2;
  } else if (currentStep.value === 2) {
    isOpen.value = false;
  }
};

const handleBack = () => {
  if (currentStep.value > 0) {
    currentStep.value = currentStep.value - 1;
  }
};

const handleCancel = () => {
  isOpen.value = false;
};
</script>
